// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as FormInput$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as FormTextInput$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";

function SegmentNamesInput(Props) {
  var value = Props.value;
  var onChange = Props.onChange;
  return React.createElement("div", {
              className: "ald-create-form-item",
              style: {
                marginTop: "16px"
              }
            }, React.createElement("div", {
                  className: "ald-create-form-item-label"
                }, "Segment Names"), React.createElement(FormTextInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("", onChange, false, undefined, "Enter segment names separated by commas (e.g., NEW_CUSTOMER, PREMIUM_USER)", undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
                        TAG: /* Text */0,
                        _0: "Enter multiple segment names separated by commas"
                      }, undefined, undefined, undefined, undefined, undefined),
                  textinput_props: {
                    value: value
                  }
                }));
}

var make = SegmentNamesInput;

export {
  make ,
  
}
/* react Not a pure module */
